import { BehaviorSubject } from 'rxjs';
let instance;
class DeviceManager {
  #deviceSubject = new BehaviorSubject('');

  initialize = async (method = () => {}) => {
    this.#deviceSubject.subscribe(method);
    console.warn('DeviceManager 등록 완료');
    return true;
  };
  reduce = (action) => {
    this.#deviceSubject.next(action);
  };

  actions = {
    FIRST_RUN: 'FIRST_RUN',
    UPDATE: 'UPDATE',
    REDIRECT: 'REDIRECT'
  };
}
export default (() => {
  if (!instance) instance = new DeviceManager();
  return instance;
})();
